import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Products() {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [sortBy, setSortBy] = useState('popular');
  const [showFilters, setShowFilters] = useState(false);

  const categories = [
    { id: 'all', name: 'الكل' },
    { id: 'groceries', name: 'بقالات' },
    { id: 'beverages', name: 'مشروبات' },
    { id: 'cleaning', name: 'منظفات' },
    { id: 'frozen', name: 'مجمدات' }
  ];

  const products = [
    { id: 1, name: 'أرز بسمتي هندي - 5 كجم', price: 45, oldPrice: 55, image: 'https://public.readdy.ai/ai/img_res/566eff51e616f790a0adfcb651c03f6d.jpg', rating: 4.8, category: 'groceries', available: true },
    { id: 2, name: 'زيت زيتون بكر ممتاز - 1 لتر', price: 89, image: 'https://readdy.ai/api/search-image?query=extra%20virgin%20olive%20oil%20bottle%201%20liter%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20high%20quality%20commercial%20photo%2C%20centered%20composition%2C%20soft%20lighting%2C%20realistic%20details&width=200&height=200&seq=p2&orientation=squarish', rating: 4.9, category: 'groceries', available: true },
    { id: 3, name: 'حليب طازج كامل الدسم - 2 لتر', price: 18, image: 'https://readdy.ai/api/search-image?query=fresh%20whole%20milk%20carton%202%20liters%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20high%20quality%20commercial%20photo%2C%20centered%20composition%2C%20soft%20lighting%2C%20realistic%20details&width=200&height=200&seq=p3&orientation=squarish', rating: 4.7, category: 'beverages', available: true },
    { id: 4, name: 'عصير برتقال طبيعي - 1 لتر', price: 12, image: 'https://readdy.ai/api/search-image?query=natural%20orange%20juice%20bottle%201%20liter%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20high%20quality%20commercial%20photo%2C%20centered%20composition%2C%20soft%20lighting%2C%20realistic%20details&width=200&height=200&seq=p4&orientation=squarish', rating: 4.6, category: 'beverages', available: true },
    { id: 5, name: 'مسحوق غسيل - 3 كجم', price: 35, oldPrice: 42, image: 'https://readdy.ai/api/search-image?query=laundry%20detergent%20powder%20box%203kg%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20high%20quality%20commercial%20photo%2C%20centered%20composition%2C%20soft%20lighting%2C%20realistic%20details&width=200&height=200&seq=p5&orientation=squarish', rating: 4.5, category: 'cleaning', available: true },
    { id: 6, name: 'معجون أسنان - عبوة 3 قطع', price: 28, image: 'https://readdy.ai/api/search-image?query=toothpaste%20pack%20of%203%20tubes%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20high%20quality%20commercial%20photo%2C%20centered%20composition%2C%20soft%20lighting%2C%20realistic%20details&width=200&height=200&seq=p6&orientation=squarish', rating: 4.8, category: 'groceries', available: false },
    { id: 7, name: 'دجاج مجمد - 1 كجم', price: 22, image: 'https://readdy.ai/api/search-image?query=frozen%20chicken%20package%201kg%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20high%20quality%20commercial%20photo%2C%20centered%20composition%2C%20soft%20lighting%2C%20realistic%20details&width=200&height=200&seq=p7&orientation=squarish', rating: 4.7, category: 'frozen', available: true },
    { id: 8, name: 'بطاطس مقلية مجمدة - 2.5 كجم', price: 32, image: 'https://readdy.ai/api/search-image?query=frozen%20french%20fries%20bag%202.5kg%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20high%20quality%20commercial%20photo%2C%20centered%20composition%2C%20soft%20lighting%2C%20realistic%20details&width=200&height=200&seq=p8&orientation=squarish', rating: 4.6, category: 'frozen', available: true }
  ];

  const filteredProducts = products.filter(p => 
    selectedCategory === 'all' || p.category === selectedCategory
  );

  return (
    <div className="min-h-screen bg-[#F6F6F6] pb-20" style={{ fontFamily: 'Cairo, sans-serif' }}>
      {/* Top Navigation */}
      <div className="fixed top-0 left-0 right-0 bg-white z-50 shadow-sm">
        <div className="px-4 py-4 flex items-center gap-3">
          <button onClick={() => navigate('/home')} className="w-10 h-10 flex items-center justify-center">
            <i className="ri-arrow-right-line text-[#212121] text-2xl"></i>
          </button>
          <h1 className="text-[#212121] text-lg font-bold flex-1">المنتجات</h1>
          <button onClick={() => setShowFilters(!showFilters)} className="w-10 h-10 flex items-center justify-center">
            <i className="ri-filter-3-line text-[#212121] text-xl"></i>
          </button>
        </div>

        {/* Search Bar */}
        <div className="px-4 pb-4">
          <div className="relative">
            <input
              type="text"
              placeholder="ابحث عن منتج..."
              className="w-full pr-12 pl-4 py-3 rounded-xl bg-[#F6F6F6] text-[#212121] placeholder-gray-400 border-none focus:outline-none"
            />
            <i className="ri-search-line absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 text-xl"></i>
          </div>
        </div>

        {/* Categories */}
        <div className="px-4 pb-3 overflow-x-auto scrollbar-hide">
          <div className="flex gap-2">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setSelectedCategory(cat.id)}
                className={`px-5 py-2 rounded-full whitespace-nowrap font-medium text-sm transition-all ${
                  selectedCategory === cat.id
                    ? 'bg-[#0D47A1] text-white shadow-lg'
                    : 'bg-white text-gray-600'
                }`}
              >
                {cat.name}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Filters Modal */}
      {showFilters && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-end" onClick={() => setShowFilters(false)}>
          <div className="bg-white w-full rounded-t-3xl p-6 animate-slide-up" onClick={(e) => e.stopPropagation()}>
            <div className="w-12 h-1 bg-gray-300 rounded-full mx-auto mb-6"></div>
            <h3 className="text-[#212121] text-lg font-bold mb-4">الترتيب حسب</h3>
            
            <div className="space-y-3">
              {[
                { id: 'popular', name: 'الأكثر شعبية' },
                { id: 'price-low', name: 'السعر: من الأقل للأعلى' },
                { id: 'price-high', name: 'السعر: من الأعلى للأقل' },
                { id: 'rating', name: 'الأعلى تقييماً' },
                { id: 'new', name: 'الأحدث' }
              ].map((sort) => (
                <button
                  key={sort.id}
                  onClick={() => {
                    setSortBy(sort.id);
                    setShowFilters(false);
                  }}
                  className={`w-full text-right px-4 py-3 rounded-xl transition-all ${
                    sortBy === sort.id
                      ? 'bg-[#0D47A1]/10 text-[#0D47A1] font-bold'
                      : 'bg-gray-50 text-gray-700'
                  }`}
                >
                  {sort.name}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Content */}
      <div className="pt-52 px-4">
        <div className="flex items-center justify-between mb-4">
          <p className="text-gray-600 text-sm">{filteredProducts.length} منتج</p>
          <button className="text-[#0D47A1] text-sm font-medium">
            {sortBy === 'popular' ? 'الأكثر شعبية' : 'مرتب'}
          </button>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-2 gap-3" data-product-shop>
          {filteredProducts.map((product) => (
            <button
              key={product.id}
              onClick={() => navigate(`/product/${product.id}`)}
              className="bg-white rounded-2xl overflow-hidden shadow-sm active:scale-95 transition-transform"
            >
              <div className="relative h-44 bg-gray-100">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover object-top" />
                {product.oldPrice && (
                  <div className="absolute top-2 left-2 bg-[#FF8F00] text-white text-xs font-bold px-2 py-1 rounded-full">
                    خصم
                  </div>
                )}
                <div className={`absolute top-2 right-2 ${product.available ? 'bg-[#4CAF50]' : 'bg-gray-400'} text-white text-xs font-bold px-2 py-1 rounded-full`}>
                  {product.available ? 'متوفر' : 'غير متوفر'}
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-[#212121] text-sm font-bold mb-2 text-right line-clamp-2 h-10">{product.name}</h3>
                <div className="flex items-center gap-1 mb-2">
                  <i className="ri-star-fill text-[#FF8F00] text-xs"></i>
                  <span className="text-gray-600 text-xs">{product.rating}</span>
                </div>
                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-[#0D47A1] text-lg font-bold">{product.price} ر.س</span>
                    {product.oldPrice && (
                      <span className="text-gray-400 text-xs line-through mr-2">{product.oldPrice}</span>
                    )}
                  </div>
                  <button className="w-8 h-8 bg-[#0D47A1] rounded-full flex items-center justify-center">
                    <i className="ri-add-line text-white text-lg"></i>
                  </button>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Bottom Navigation */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
        <div className="grid grid-cols-5 h-16">
          <button onClick={() => navigate('/home')} className="flex flex-col items-center justify-center gap-1">
            <i className="ri-home-5-line text-gray-400 text-xl"></i>
            <span className="text-gray-400 text-[0.625rem]">الرئيسية</span>
          </button>
          <button className="flex flex-col items-center justify-center gap-1">
            <i className="ri-grid-fill text-[#0D47A1] text-xl"></i>
            <span className="text-[#0D47A1] text-[0.625rem] font-medium">المنتجات</span>
          </button>
          <button onClick={() => navigate('/cart')} className="flex flex-col items-center justify-center gap-1 relative">
            <i className="ri-shopping-cart-line text-gray-400 text-xl"></i>
            <span className="text-gray-400 text-[0.625rem]">السلة</span>
            <span className="absolute top-1 right-1/2 translate-x-3 w-4 h-4 bg-[#FF8F00] text-white text-[0.5rem] font-bold rounded-full flex items-center justify-center">3</span>
          </button>
          <button onClick={() => navigate('/orders')} className="flex flex-col items-center justify-center gap-1">
            <i className="ri-file-list-line text-gray-400 text-xl"></i>
            <span className="text-gray-400 text-[0.625rem]">الطلبات</span>
          </button>
          <button onClick={() => navigate('/profile')} className="flex flex-col items-center justify-center gap-1">
            <i className="ri-user-line text-gray-400 text-xl"></i>
            <span className="text-gray-400 text-[0.625rem]">الحساب</span>
          </button>
        </div>
      </div>

      <style>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        @keyframes slide-up {
          from {
            transform: translateY(100%);
          }
          to {
            transform: translateY(0);
          }
        }
        .animate-slide-up {
          animation: slide-up 0.3s ease-out;
        }
      `}</style>
    </div>
  );
}